import { jsxs as _jsxs } from "react/jsx-runtime";
import { ProductVersionTypography } from "../../../components/atoms/ProductVersion/components/ProductVersion.components.js";
export const ProductVersionAtomComponent = ({ productName, version, ...props }) => (_jsxs(ProductVersionTypography, { "data-testid": "ProductVersion", ...props, size: "medium", variant: "label", children: [productName, " ", version] }));
export default ProductVersionAtomComponent;
